import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as reportsActions from '../../actions/Reports';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocaleComponent from '../../LocaleComponent';
import SearchBox from '../../components/SearchBox';
import FilterDropDown from '../../components/FilterDropDown';
import { statusFormatter } from '../Formatter';
import downloadCSV from '../../libs/donwloadCSV';

function urlFormatter(url) {
  return (
    <p><a href={url} target="_blank">{url}</a></p>
  );
}

class Pages extends LocaleComponent {

  constructor(props) {
    super(props);

    this.state = {
      params: {
        searchText: '',
        typeFilter: this._all,
        statusFilter: this._all,
      },
      availableTypes: [],
      availableStatuses: [],
      filteredData: [],
      modal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { pages, location } = nextProps;
    const params = this.parseParams(location.search);
    this.load(params, {pages});
  }

  componentDidMount() {
    const newParams = this.checkParams();

    if (newParams) {
      this.mergeParams(newParams);
    }
    const id = this.getMcId();

    this.props.getLandingPages(id);
    this.props.selectMenu('pages');
  }

  onTypeFilterClick = typeFilter => {
    const path = this.stringfyWithNew({ typeFilter });
    this.props.history.replace(path);
    this.load({ typeFilter });
  };

  onStatusFilterClick = statusFilter => {
    const path = this.stringfyWithNew({ statusFilter });
    this.props.history.replace(path);
    this.load({ statusFilter });
  };

  onSearchTextChanged = e => {
    const searchText = e.target.value;
    const path = this.stringfyWithNew({ searchText });
    this.props.history.replace(path);
    this.load({ searchText });
  };

  onDownloadClick() {
    const { filteredData } = this.state;
    if (!downloadCSV('pages.csv', filteredData)) {
      this.setState({ modal: true });
    }
  }

  load(newParam, newState) {
    const { pages } = this.mergeValues(this.state, newState);
    const { searchText, typeFilter, statusFilter } = this.mergeValues(this.state.params, newParam);
    const availableTypes = [this._all];
    const availableStatuses = [this._all];

    this.props.setSpin(true);

    pages.forEach(item => {
      item.page_type = 'keyword';
      if (item.page_type && availableTypes.indexOf(item.page_type) === -1) {
        availableTypes.push(item.page_type)
      }
      if (item.status && availableStatuses.indexOf(item.status) === -1) {
        availableStatuses.push(item.status)
      }
    });

    const filteredData = pages.filter(item => {
      return (
          (typeFilter !== this._all) ?
            (item.page_type.toString() === typeFilter) : true
        ) && (
          (statusFilter !== this._all) ?
            (item.status.toString() === statusFilter) : true
        ) && (
          (searchText !== '') ?
          (item.page_name && item.page_name.indexOf(searchText) !== -1) ||
          (item.page_url && item.page_url.indexOf(searchText) !== -1)
            : true
        );
    });

    const updatedStates = Object.assign({},
      {
        availableTypes,
        availableStatuses,
        filteredData,
      },
      newState,
      {
        params: this.mergeValues(this.state.params, newParam)
      });

    this.setState(updatedStates);

    this.props.setSpin(false);
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  render() {
    const {
      availableTypes,
      availableStatuses,
      filteredData,
      modal,
      params,
    } = this.state;
    const { searchText, typeFilter, statusFilter } = params;

    const filterBox = (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-btn">
            <span className="input-group-addon">
              <i className="fa fa-filter" /> &nbsp;
              {this.localeMessage('Filter')}
            </span>
            <FilterDropDown title={this.localeMessage('Type')}
                            data={availableTypes}
                            filter={typeFilter}
                            onClick={this.onTypeFilterClick}
            />
            <FilterDropDown title={this.localeMessage('Status')}
                            data={availableStatuses}
                            filter={statusFilter}
                            onClick={this.onStatusFilterClick}
            />
          </div>
        </div>
      </div>
    );

    const DataTable = props => {
      const itemCount = props.data.length;

      const renderPaginationPanel = (props) => {
        return (
          <div style={{margin: '20px'}}>
            <div>{ props.components.pageList }</div>
            <div>
              <span>{this.localeMessage('Change size per page')}: </span>
              { props.components.sizePerPageDropdown }
              <span>Total {itemCount}</span>
            </div>
          </div>
        );
      };

      const pagination = itemCount > 10;
      const options = pagination ? {
        paginationPanel: renderPaginationPanel,
        sizePerPageList: [
          { text: '50', value: 50 },
          { text: '100', value: 100 },
          { text: '200', value: 200 },
          { text: 'All', value: itemCount} ],
        sizePerPage: 50,
      } : {};

      return (
        <BootstrapTable data={props.data} options={options} pagination={pagination}>
          <TableHeaderColumn width='200' dataField={'page_name'} isKey>
            {this.localeMessage('Name')}
          </TableHeaderColumn>
          <TableHeaderColumn dataField={'page_url'} dataFormat={urlFormatter}>
            {this.localeMessage('URL')}
          </TableHeaderColumn>
          <TableHeaderColumn width='100' dataField={'page_type'}>
            {this.localeMessage('Type')}
          </TableHeaderColumn>
          <TableHeaderColumn width='100' dataField={'status'} dataFormat={statusFormatter}>
            {this.localeMessage('Status')}
          </TableHeaderColumn>
        </BootstrapTable>
      );
    };

    return (
      <div>
        <div className="row">
          <div className="col-lg-3">
            <SearchBox searchText={searchText} onSearchTextChanged={this.onSearchTextChanged}/>
          </div>
          <div className="col-lg-7">
            {filterBox}
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <button type="button" className="btn btn-default btn-sm" onClick={() => this.onDownloadClick()}>
                <i className="fa fa-download" />&nbsp; {this.localeMessage('Download')}
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DataTable data={filteredData}/>
          </div>
        </div>
        <Modal isOpen={modal} toggle={this.toggle} className={'modal-success ' + this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.localeMessage('Download')}</ModalHeader>
          <ModalBody>
            No data
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

class PagesContainer extends Component {
  render() {
    return <Pages
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

PagesContainer = connect(state => ({
  campaigns: state.reports.get('campaigns'),
  pages: state.reports.get('pages'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(PagesContainer);

export default PagesContainer;



// WEBPACK FOOTER //
// ./src/views/Pages/Pages.js